/**
 * Modulo para las tareas
 */
import DialogConfirmarConComentarioCtrl from "./dialogConfirmarConComentarioCtrl";
import TareaActionsService from "./tareaActionsService";
import TareasGridCtrl from "./tareasGridCtrl";
import TareasService from "./tareasService";
import DialogEditEstadoTareaCtrl from "./edit-estado/dialogEditEstadoTareaCtrl";
import FechaIniPrevistaDialogCtrl from "./fecha-ini-prevista/fechaIniPrevistaDialogCtrl";
import TareasFinalizarDialogCtrl from "./finalizar/tareasFinalizarDialogCtrl";
import SelectListaDialogCtrl from "./listas/selectListaDialogCtrl";
import EditTareaDialogCtrl from "./editTareaDialogCtrl";
import IncidenciaActionsService from "../incidencias/incidenciaActionsService";
import IncidenciaService from "../incidencias/incidenciasService";
import EditIncidenciaDialogCtrl from "../incidencias/editIncidenciaDialogCtrl";
import CiudadanoCtrl from "../incidencias/ciudadano/ciudadanoCtrl";
import CiudadanoIncidenciaService from "../incidencias/ciudadano/ciudadanoService";
import ComentarioIncidenciaDataService from "../comentarios/comentarioIncidenciaService";
import ComentarioTareaDataService from "../comentarios/comentarioTareaService";
import ComentariosCtrl from "../comentarios/comentariosCtrl";
import ComentariosDirectiva from '../comentarios/comentariosDirectiva';
import EnviosEntidadesModule from '../envios-entidades/enviosEntidades.module';
import EnvioEntidadService from "../envios-entidades/enviosEntidadesService";
import AppModule from "../app.module";

const angular = require('angular');
import ngResourceModuleName from 'angular-resource';
import CostesDetallesDirectiva from "../costes/costes-detalles/costesDetallesDirectiva";
import CostesActionsService from "../costes/CostesActionsService";
import CostesEditModalCtrl from "../costes/costes-edit-modal/costesEditModalCtrl";
import CostesDetallesCtrl from "../costes/costes-detalles/costesDetallesCtrl";

require('ment.io');

import TareasTiemposDetallesDirectiva from "../tareas-tiempos/tareas-tiempos-detalles/TareasTiemposDetallesDirectiva";
import TareasTiemposDetallesCtrl from "../tareas-tiempos/tareas-tiempos-detalles/TareasTiemposDetallesCtrl";

typeof EnviosEntidadesModule;

import TaskCommentsDirective from "./task-comments/taskCommentsDirective";
import TaskCommentsCtrl from "./task-comments/taskCommentsCtrl";

const TareasModule = angular
    .module('tareas', ['app', 'incidencias', ngResourceModuleName, 'mentio'])
    .service('EnvioEntidad', EnvioEntidadService) // Esta en envio entidades
    .service('CiudadanoIncidencia', CiudadanoIncidenciaService) // Esta en incidencias
    .controller('CiudadanoCtrl', CiudadanoCtrl) // Esta en incidencias
    .service('Incidencia', IncidenciaService) // Esta en incidencias
    .service('IncidenciaActionsService', IncidenciaActionsService) // Esta en incidencias
    .controller('DialogConfirmarConComentarioCtrl', DialogConfirmarConComentarioCtrl)
    .controller('EditTareaDialogCtrl', EditTareaDialogCtrl)
    .service('TareaActionsService', TareaActionsService)
    .controller('TareasGridCtrl', TareasGridCtrl)
    .service('Tarea', TareasService)
    .controller('DialogEditEstadoTareaCtrl', DialogEditEstadoTareaCtrl)
    .controller('TareasFinalizarDialogCtrl', TareasFinalizarDialogCtrl)
    .controller('SelectListaDialogCtrl', SelectListaDialogCtrl)
    .service('ComentarioTarea', ComentarioTareaDataService)
    .service('ComentarioIncidencia', ComentarioIncidenciaDataService)
    .directive('comentarios', ComentariosDirectiva)
    .controller('ComentariosCtrl', ComentariosCtrl)
    .controller('EditIncidenciaDialogCtrl', EditIncidenciaDialogCtrl)

    .service('CostesActionsService', CostesActionsService)
    .directive('costesDetalles', CostesDetallesDirectiva)
    .controller('CostesEditModalCtrl', CostesEditModalCtrl)
    .controller('CostesDetallesCtrl', CostesDetallesCtrl)

    .directive("tareasTiempos", TareasTiemposDetallesDirectiva)
    .controller("TareasTiemposDetallesCtrl", TareasTiemposDetallesCtrl)

    .directive("taskComments", TaskCommentsDirective)
    .controller("TaskCommentsCtrl", TaskCommentsCtrl)

    .controller("FechaIniPrevistaDialogCtrl", FechaIniPrevistaDialogCtrl)
;

export default TareasModule;